import '.f{width:100%;}.ssr-plugin'
import '.t{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.gq{min-height:44px;}.ssr-plugin'
import '.gr{padding:0 16px 0 12px;}.ssr-plugin'
import '.d2{gap:8px;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.bv{margin-left:auto;}.ssr-plugin'
import '.gs{overflow-y:auto;}.ssr-plugin'
import '.gt{overflow-x:hidden;}.ssr-plugin'
import '.ej{gap:2px;}.ssr-plugin'
import '.a8{gap:4px;}.ssr-plugin'
import { useState } from 'react'
import { ItemActions } from '../../utils/common.js'
import { Text } from '../Text/index.js'
import { IconButton } from '../IconButton/index.js'
import { CheckboxInput } from '../CheckboxInput/index.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Icon, IconProps } from '../Icon/index.js'
import { ListItem } from './ListItem.js'
import { Style, styled } from 'inlines'

type ListProps = {
  data: any[]
  fields: Record<any, any>
  flushItems?: boolean
  title?: string
  select?: any
  cleanMode?: boolean
  onSelectChange?: (select?: any) => void
  collapsible?: boolean
  onItemClick?: (item: any) => void
  itemActions?: ItemActions
  placeholder?: string
  placeholderIcon?: IconProps['variant']
  disabled?: boolean
  error?: boolean
  onOrderChange?: (draggedId: string, targetIdx: number) => void
  onRemove?: (item: any) => void
  style?: Style
}

function List({
  title,
  collapsible,
  onSelectChange,
  data,
  select,
  cleanMode,
  fields,
  flushItems,
  onItemClick,
  onOrderChange,
  itemActions,
  placeholder,
  placeholderIcon,
  error,
  disabled,
  onRemove,
  style,
}: ListProps) {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <styled.div className="f t a i"
      style={{
        ...style,
      }}
    >
      {title && !cleanMode && (
        <styled.div className="a d gq gr d2"
          style={{
            border: `1px solid ${colors.neutral20Adjusted}`,
            background: colors.neutral5,
            borderTopLeftRadius: radius[20],
            borderTopRightRadius: radius[20],
            ...(collapsed && {
              borderBottomLeftRadius: radius[20],
              borderBottomRightRadius: radius[20],
            }),
          }}
        >
          {onSelectChange && (
            <CheckboxInput
              size="small"
              value={select?.length === data?.length}
              onChange={() => {
                if (select?.length !== data?.length) {
                  onSelectChange(data)
                } else {
                  onSelectChange(undefined)
                }
              }}
            />
          )}
          <Text variant="display-medium" color="neutral80">
            {title}
          </Text>
          {collapsible && (
            <div className="a c d bv"
            >
              <IconButton
                size="small"
                icon={collapsed ? 'chevron-left' : 'chevron-down'}
                onClick={() => {
                  setCollapsed((p) => !p)
                }}
              />
            </div>
          )}
        </styled.div>
      )}
      {!collapsed && (
        <styled.div className="t gs gt ej a i"
          style={{
            padding: flushItems ? undefined : 8,
            ...(!cleanMode && {
              borderLeft: `1px solid ${colors.neutral20Adjusted}`,
              borderRight: `1px solid ${colors.neutral20Adjusted}`,
              borderBottom: `1px solid ${colors.neutral20Adjusted}`,
              borderBottomLeftRadius: radius[20],
              borderBottomRightRadius: radius[20],
              ...(!title && {
                borderTop: `1px solid ${colors.neutral20Adjusted}`,
                borderTopLeftRadius: radius[20],
                borderTopRightRadius: radius[20],
              }),
            }),
            ...(error && {
              borderLeft: `1px solid ${colors.red80}`,
              borderRight: `1px solid ${colors.red80}`,
              borderBottom: `1px solid ${colors.red80}`,
              ...(!title && {
                borderTop: `1px solid ${colors.red80}`,
              }),
            }),
            ...(disabled && {
              cursor: 'not-allowed',
              color: colors.neutral20,
              background: colors.neutral5,
              borderLeft: `1px solid transparent`,
              borderRight: `1px solid transparent`,
              borderBottom: `1px solid transparent`,
              ...(!title && {
                borderTop: `1px solid transparent`,
              }),
            }),
          }}
        >
          {data?.length > 0 ? (
            data.map((item, idx) => (
              <ListItem
                key={`${idx}-${item?.id}`}
                idx={idx}
                item={item}
                disabled={disabled}
                fields={fields}
                flushItems={flushItems}
                cleanMode={cleanMode}
                selected={!!select?.find(({ id }) => id === item?.id)}
                onClick={onItemClick && (() => onItemClick(item))}
                onSelectChange={
                  onSelectChange &&
                  ((selected) => {
                    onSelectChange(
                      selected
                        ? [...(select ?? []), item]
                        : select?.filter(({ id }) => id !== item.id),
                    )
                  })
                }
                itemActions={itemActions}
                onOrderChange={onOrderChange}
                onRemove={onRemove}
              />
            ))
          ) : (
            <div className="f t c d a i a8"
              style={{
                color: colors.neutral60,
              }}
            >
              {placeholderIcon && <Icon variant={placeholderIcon} />}
              {placeholder && (
                <Text variant="subtext-medium" color="inherit">
                  {placeholder}
                </Text>
              )}
            </div>
          )}
        </styled.div>
      )}
    </styled.div>
  )
}

export { List }
export type { ListProps }
